import { getCookie } from '../helpers/getCookie';

export const getAdsIds = (): Record<string, string | null> => {
  const cleanValue = (value: string | null): string | null =>
    value?.trim().replace(/%22/g, '').replace(/"/g, '') || null;

  const getParam = (key: string): string | null => {
    const value = getCookie(key) || null;
    return cleanValue(value);
  };

  const paramMap = {
    _rid_gclid_id: 'gclid_lc',
    _rid_gbraid_id: 'gbraid_lc',
    _rid_fbclid_id: 'fbclid_lc',
    _rid_wbraid_id: 'wbraid_lc',
    _rid_ttclid_id: 'ttclid_lc',
    _rid_yclid_id: 'yclid_lc',
    _rid_utm_source_id: 'utm_source_lc',
    _rid_utm_medium_id: 'utm_medium_lc',
    _rid_utm_campaign_id: 'utm_campaign_lc',
    _rid_utm_content_id: 'utm_content_lc',
    _rid_utm_term_id: 'utm_term_lc',
  };

  const result: Record<string, string | null> = {};

  Object.entries(paramMap).forEach(([storageKey, resultKey]) => {
    result[resultKey] = getParam(storageKey);
  });

  return result;
};

export default getAdsIds;
